import { bootstrapIconUrl } from '@/config/urls.js'

export enum BootstrapIcon {
  PersonCircle = 'person-circle',
  SortUp = 'sort-up',
  SortDown = 'sort-down',
  InfoCircle = 'info-circle',
  Search = 'search',
  EmojiSmile = 'emoji-smile',
  ChevronDownIcon = 'chevron-down',
  ChevronLeft = 'chevron-left',
  ChevronRight = 'chevron-right',
  List = 'list',
  X = 'x-lg',
  Bell = 'bell',
  Home = 'house',
  FileText = 'file-text',
  Gear = 'gear',
  Eye = 'eye',
  EyeSlash = 'eye-slash',
  Wallet = 'wallet',
  ShieldLock = 'shield-lock',
  PatchExclamation = 'patch-exclamation',
  Collection = 'collection',
  CheckLg = 'check-lg',
  DashLg = 'dash-lg',
  Box = 'box',
  Bank = 'bank',
  CreditCard = 'credit-card',
}

export function tryParseBootstrapIcon(iconName: string): BootstrapIcon | null {
  const enumKey = iconName
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('') as keyof typeof BootstrapIcon

  if (enumKey in BootstrapIcon) {
    return BootstrapIcon[enumKey]
  }
  return null
}

export function getBootstrapIconUrl(iconName: BootstrapIcon): string {
  return bootstrapIconUrl(iconName)
}

// Helper function to convert kebab-case to PascalCase and get icon URL
export function getBootstrapIconUrlByKey(iconKey: string): string {
  const enumKey = tryParseBootstrapIcon(iconKey)
  if (!enumKey) {
    throw new Error(`Icon '${iconKey}' is not in the pre-approved BootstrapIcon enum`)
  }

  // Get the enum value and return the URL
  return getBootstrapIconUrl(enumKey)
}
